export enum PeopleTab {
  PEOPLE = 'People',
  UNKNOWN_PEOPLE = 'Unknown'
}
